<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer020">
<p class="part-number-with-part-title" id="_idParaDest-3" lang="en-US">PART ONE</p>
<p class="part-title-with-part-number" lang="en-US">A Momentary Lapse of Reason</p>
<p class="part-title-with-part-number" lang="en-US"><em class="italic" lang="en-US">Macau, 1994</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781504082006-3.vue?17cb5469